import http from "../../http-common";

class TeacherService {
  getClassInTeacher() {
    return http.get(`/teacher/class`);
  }

  getClassesAndKids() {
    return http.get(`/form/get-classAndKids`);
  }

  getKidsAndTeacher() {
    return http.get(`/form/get-teacherAndKids`);
  }
}
export default new TeacherService();